export var CONTEXT_NAMESPACE = '__react_css_component_cache';
export var ID_NAMESPACE = '__react_css_component_id-';